var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center py-2"},[_c('HalfCircleSpinner',{attrs:{"animation-duration":1000,"size":65,"color":'#fa651d'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }